import { Response } from "services/types";
import { AddLogoDesignFileRequest, AddQuoteRequestModel, Brand, DeleteQuotesRequest, EditQuoteRequestModel, EmailQuoteRequest, LogoLocation, OrderQuote, QuotedProduct, SubmitQuotesRequest } from "./types";
export class OrderService {
  async getOrders(): Promise<Response<OrderQuote[]>> {
    const token = localStorage.getItem('token') ?? '';
    const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/sales_order` ?? '', {
      method: "GET",
      headers: {
        'Access-Control-Allow-Origin': '*',
        "Authorization": `Bearer ${token}`
      }
    });
    const getOrdersResponse: Response<OrderQuote[]> = await response.json();

    return getOrdersResponse;
  }

  async getOrderById(id?: number): Promise<Response<OrderQuote>> {
    const token = localStorage.getItem('token') ?? '';
    const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/sales_order${id ? `?id=${id}` : ``}` ?? '', {
      method: "GET",
      headers: {
        'Access-Control-Allow-Origin': '*',
        "Authorization": `Bearer ${token}`
      }
    });
    const getOrderByIdResponse: Response<OrderQuote> = await response.json();

    return getOrderByIdResponse;
  }

  async viewQuote(id: number, brand: Brand): Promise<Response<string>> {
    const token = localStorage.getItem('token') ?? '';
    const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/sales_order/quote?id=${id}&brand=${brand}` ?? '', {
      method: "GET",
      headers: {
        'Access-Control-Allow-Origin': '*',
        "Authorization": `Bearer ${token}`
      }
    });
    const getOrdersResponse: Response<string> = await response.json();

    return getOrdersResponse;
  }

  async downloadQuote(id: number, brand: Brand): Promise<Blob> {
    const token = localStorage.getItem('token') ?? '';
    const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/sales_order/quote_pdf?id=${id}&brand=${brand}` ?? '', {
      method: "GET",
      headers: {
        'Access-Control-Allow-Origin': '*',
        "Authorization": `Bearer ${token}`
      }
    });

    return response.blob();
  }

  async downloadShopworksFile(id: number): Promise<Blob> {
    const token = localStorage.getItem('token') ?? '';
    const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/sales_order/shopworks?id=${id}` ?? '', {
      method: "GET",
      headers: {
        'Access-Control-Allow-Origin': '*',
        "Authorization": `Bearer ${token}`
      }
    });

    return response.blob();
  }

  async deleteQuotes(request: DeleteQuotesRequest): Promise<Response<void>> {
    const token = localStorage.getItem('token') ?? '';
    const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/sales_order` ?? '', {
      method: "DELETE",
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify(request),
    });
    const getOrdersResponse: Response<void> = await response.json();

    return getOrdersResponse;
  }

  async submitQuotes(request: SubmitQuotesRequest): Promise<Response<void>> {
    const token = localStorage.getItem('token') ?? '';
    const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/sales_order/send` ?? '', {
      method: "POST",
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify(request),
    });
    const getOrdersResponse: Response<void> = await response.json();

    return getOrdersResponse;
  }

  async addQuote(request: AddQuoteRequestModel): Promise<Response<OrderQuote>> {
    const token = localStorage.getItem('token') ?? '';
    const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/sales_order` ?? '', {
      method: "POST",
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(request),
    });
    const addQuoteResponse: Response<OrderQuote> = await response.json();

    return addQuoteResponse;
  }

  async editQuote(request: EditQuoteRequestModel): Promise<Response<OrderQuote>> {
    const token = localStorage.getItem('token') ?? '';
    const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/sales_order?id=${request.id}` ?? '', {
      method: "PUT",
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(request),
    });
    const editQuoteResponse: Response<OrderQuote> = await response.json();

    return editQuoteResponse;
  }

  async getProductsByQuoteId(id: number): Promise<Response<QuotedProduct[]>> {
    const token = localStorage.getItem('token') ?? '';
    const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/sales_order/products?id=${id}` ?? '', {
      method: "GET",
      headers: {
        'Access-Control-Allow-Origin': '*',
        "Authorization": `Bearer ${token}`
      }
    });
    const getProductsByQuoteIdResponse: Response<QuotedProduct[]> = await response.json();

    return getProductsByQuoteIdResponse;
  }

  async getLogosByQuoteId(id: number): Promise<Response<LogoLocation[]>> {
    const token = localStorage.getItem('token') ?? '';
    const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/sales_order/logos?id=${id}` ?? '', {
      method: "GET",
      headers: {
        'Access-Control-Allow-Origin': '*',
        "Authorization": `Bearer ${token}`
      }
    });
    const getLogosByQuoteIdResponse: Response<LogoLocation[]> = await response.json();

    return getLogosByQuoteIdResponse;
  }

  async addLogo(request: AddLogoDesignFileRequest): Promise<Response<void>> {
    const token = localStorage.getItem('token') ?? '';
    const formData = new FormData()
    for (const key in request) {
      if (key !== 'designs') {
        formData.append(key, `${request[key as keyof AddLogoDesignFileRequest]}`);
      }
    }

    request.designs?.forEach(design => {
      formData.append("designs", design);
    });

    const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/sales_order/logo` ?? '', {
      method: "POST",
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': `Bearer ${token}`
      },
      body: formData,
    });

    const addLogoResponse: Response<void> = await response.json();

    return addLogoResponse;
  }

  async emailQuotes(request: EmailQuoteRequest): Promise<Response<void>> {
    const token = localStorage.getItem('token') ?? '';
    const response = await fetch(`${process.env.REACT_APP_BACKEND_ENPOINT}api/sales_order/email_quote`, {
      method: "POST",
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(request),
    });
    const getOrdersResponse: Response<void> = await response.json();

    return getOrdersResponse;
  }
}

const orderService = new OrderService();

export default orderService;
